import { Component } from '@verndale/core';

class Module extends Component {
  private isInit: boolean = true;
  private activeTabId: string = '';
  private tabs: HTMLElement[] = [];

  setupDefaults() {
    this.dom = {
      tabContent: this.el.querySelectorAll('.tab-row__content'),
      select: this.el.querySelector<HTMLElement>('.tab-row__select'),
      buttonsContainer: this.el.querySelector<HTMLElement>('.tab-row__buttons'),
      buttonFlex: this.el.querySelector<HTMLElement>('.tab-row__buttons-wrapper')
    };
  }

  constructor(el: HTMLElement) {
    super(el);
    this.initial();
  }

  addListeners() {
    this.el.addEventListener('click', e => this.handleClick(e));
    (this.dom.select as HTMLElement).addEventListener('change', e => this.handleChange(e));
  }

  initial() {
    (this.dom.select as HTMLElement).innerHTML = '';
    (this.dom.buttonFlex as HTMLElement).innerHTML = '';

    const selectOptions = (this.dom.select as HTMLElement).cloneNode(true) as HTMLElement;
    const buttons = (this.dom.buttonFlex as HTMLElement).cloneNode(true) as HTMLElement;
    const tabContents = Array.from(this.dom.tabContent as NodeListOf<HTMLElement>);
    tabContents.forEach(tab => {
      const selectOption = document.createElement('option');
      selectOption.value = tab.getAttribute('id') || '';
      selectOption.textContent = tab.dataset.tabName || '';
      selectOptions.appendChild(selectOption);

      const button = document.createElement('button');
      button.classList.add('tab-row__tab-btn');
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('aria-controls', `#tab-${tab.getAttribute('id')}`);
      button.setAttribute('id', tab.getAttribute('id') || '');
      button.textContent = tab.dataset.tabName || '';

      buttons.appendChild(button);
    });

    (this.dom.select as HTMLElement).innerHTML = selectOptions.innerHTML;
    (this.dom.buttonFlex as HTMLElement).innerHTML = buttons.innerHTML;
    this.dom.options = (this.dom.select as HTMLElement).querySelectorAll('option');

    this.tabs = Array.from(this.el.querySelectorAll('.tab-row__tab-btn'));

    const urlTab = new URLSearchParams(window.location.search).get('tab');
    if (urlTab) {
      this.activateTab(this.tabs.findIndex(tab => tab.id === urlTab));
      this.activeTabId = urlTab;
      this.updateUrl();
    } else {
      this.activateTab(0);
      this.activeTabId = this.tabs[0].getAttribute('id') || '';
    }
  }

  updateUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('tab', this.activeTabId);
    window.history.pushState({}, '', url.toString());
  }

  tabChange(selectedId: string) {
    if (selectedId !== this.activeTabId) {
      this.deactivateTab(this.tabs.findIndex(tab => tab.id === this.activeTabId));
      this.activateTab(this.tabs.findIndex(tab => tab.id === selectedId));
      this.activeTabId = selectedId;
      this.updateUrl();
    }
  }

  deactivateTab(tabIndex: number) {
    if (tabIndex < 0) return;
    this.tabs[tabIndex].classList.remove('tab-row__tab-btn--selected');
    this.tabs[tabIndex].removeAttribute('tabindex');
    this.tabs[tabIndex].setAttribute('aria-selected', 'false');
    (this.dom.tabContent as NodeListOf<HTMLElement>)?.[tabIndex].classList.remove(
      'tab-row__content--selected'
    );
    (this.dom.options as NodeListOf<HTMLElement>)?.[tabIndex].setAttribute('selected', 'false');
  }

  activateTab(tabIndex: number) {
    if (tabIndex < 0) return;

    this.tabs[tabIndex].classList.add('tab-row__tab-btn--selected');
    this.tabs[tabIndex].setAttribute('tabindex', '-1');
    this.tabs[tabIndex].setAttribute('aria-selected', 'true');
    (this.dom.tabContent as NodeListOf<HTMLElement>)?.[tabIndex].classList.add(
      'tab-row__content--selected'
    );
    (this.dom.options as NodeListOf<HTMLElement>)?.[tabIndex].setAttribute('selected', 'true');

    if (!this.isInit) this.tabs[tabIndex].focus();

    this.isInit = false;
  }

  handleClick(e: Event) {
    if ((e.target as HTMLElement)?.classList.contains('tab-row__tab-btn')) {
      this.tabChange((e.target as HTMLElement).id);
    }
  }

  handleChange(e: Event) {
    this.tabChange((e.target as HTMLSelectElement)?.value);
  }
}

export default Module;
